"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.tobiIconSizes = exports.tobiIconKeys = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var TobiIcons = _interopRequireWildcard(require("../../../assets/icons/tobi/icons"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ** TOBi emojis help to be engaging and personable to users. **
 *
 * Limited use of emojis can be used to add a delight feature to journeys but must always be in favour of the customer.
 *
 * There are 3 sizes: Small, Medium, Large
 *
 */
var TobiIcon = function TobiIcon(_ref) {
  var size = _ref.size,
      tobi = _ref.tobi;
  return tobi !== "" && /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    component: TobiIcons[tobi],
    fontSize: size,
    viewBox: "0 0 68 68"
  });
};

TobiIcon.propTypes = {
  /** The Tobi icon key */
  tobi: _propTypes.default.string.isRequired,

  /** The size of the icon (18px, 24px, 32px) */
  size: _propTypes.default.oneOf(["small", "default", "large"])
};
TobiIcon.defaultProps = {
  size: "default"
};
var tobiIconKeys = Object.keys(TobiIcons);
exports.tobiIconKeys = tobiIconKeys;
var tobiIconSizes = ["small", "default", "large"];
exports.tobiIconSizes = tobiIconSizes;
var _default = TobiIcon;
exports.default = _default;